export const environment = {
    production: true,
    apiBaseUrl: 'https://api.stg.wideandheavy.com/api/',
};
